import { Reveal, Eyebrow } from "./Reveal";

const QUOTES = [
    {
        text: "Savv completely changed the way our business looks and feels.",
        accent: "#D3A0A7",
    },
    {
        text: "The creativity, attention to detail — we couldn't be happier.",
        accent: "#A9C6DE",
    },
    {
        text: "Working with Savv was the best decision for our brand.",
        accent: "#C9DDEE",
    },
    {
        text: "Our brand has never ever looked better.",
        accent: "#D3A0A7",
    },
];

export const Testimonials = () => (
    <section
        data-testid="testimonials-section"
        className="py-20 md:py-32 px-5 sm:px-8 lg:px-12"
    >
        <div className="max-w-6xl mx-auto">
            <div className="text-center mb-14 md:mb-20">
                <Reveal>
                    <Eyebrow>Don&apos;t just take our word for it.</Eyebrow>
                </Reveal>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
                {QUOTES.map((q, i) => (
                    <Reveal key={i} delay={i * 0.08} className="h-full">
                        <figure
                            data-testid={`testimonial-card-${i}`}
                            className={`bg-[#0C0C0C] rounded-3xl p-9 md:p-10 h-full border border-[#262626] ${
                                i % 2 === 1 ? "md:translate-y-6" : ""
                            }`}
                        >
                            <span
                                aria-hidden="true"
                                className="font-serif-ed text-6xl leading-[0.5]"
                                style={{ color: q.accent }}
                            >
                                &ldquo;
                            </span>
                            <blockquote className="mt-6 font-serif-ed text-2xl md:text-[1.65rem] leading-snug tracking-tight text-[#F1F1EF]">
                                {q.text}
                            </blockquote>
                            <figcaption
                                className="mt-6 font-hand text-2xl"
                                style={{ color: q.accent }}
                            >
                                ♡ a happy Savv client
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
